export const getAboutOpened = (state) => state.about.opened